/**
 * Job function categories and sub-items for discover-v2.
 * API expects departmentAndFunction.any.include = [ "c_suite", "software_development", ... ]
 * Each item: { id: apiValue, label: readableLabel }
 */
export const JOB_FUNCTION_CATEGORIES = [
  {
    id: "Engineering/Technical",
    label: "Engineering / Technical",
    items: [
      { id: "engineering_technical", label: "Engineering / Technical" },
      { id: "artificial_intelligence_machine_learning", label: "Artificial Intelligence / Machine Learning" },
      { id: "bioengineering", label: "Bioengineering" },
      { id: "biometrics", label: "Biometrics" },
      { id: "business_intelligence", label: "Business Intelligence" },
      { id: "chemical_engineering", label: "Chemical Engineering" },
      { id: "cloud_mobility", label: "Cloud & Mobility" },
      { id: "data_science", label: "Data Science" },
      { id: "devops", label: "DevOps" },
      { id: "emerging_technology_innovation", label: "Emerging Technology & Innovation" },
      { id: "industrial_engineering", label: "Industrial Engineering" },
      { id: "mechanic", label: "Mechanic" },
      { id: "mobile_development", label: "Mobile Development" },
      { id: "research_development", label: "Research & Development" },
      { id: "scrum_master_agile_coach", label: "Scrum Master / Agile Coach" },
      { id: "software_development", label: "Software Development" },
      { id: "support_technical_services", label: "Support & Technical Services" },
      { id: "technician", label: "Technician" },
      { id: "technology_operations", label: "Technology Operations" },
      { id: "test_quality_assurance", label: "Test & Quality Assurance" },
      { id: "web_development", label: "Web Development" }
    ]
  },
  {
    id: "Product/Design",
    label: "Product / Design",
    items: [
      { id: "product_management", label: "Product Management" },
      { id: "product_development", label: "Product Development" },
      { id: "ui_ux", label: "UI/UX" },
      { id: "design", label: "Design" },
      { id: "product_ui_ux_design", label: "Product / UI/UX Design" },
      { id: "graphic_design", label: "Graphic Design" }
    ]
  },
  {
    id: "Finance",
    label: "Finance",
    items: [
      { id: "finance", label: "Finance" },
      { id: "accounting", label: "Accounting" },
      { id: "financial_planning_analysis", label: "Financial Planning & Analysis" },
      { id: "financial_reporting", label: "Financial Reporting" },
      { id: "financial_strategy", label: "Financial Strategy" },
      { id: "financial_systems", label: "Financial Systems" },
      { id: "internal_audit_control", label: "Internal Audit & Control" },
      { id: "investor_relations", label: "Investor Relations" },
      { id: "mergers_acquisitions", label: "Mergers & Acquisitions" },
      { id: "financial_risk", label: "Financial Risk" },
      { id: "sourcing_procurement", label: "Sourcing & Procurement" },
      { id: "tax", label: "Tax" },
      { id: "treasury", label: "Treasury" }
    ]
  },
  {
    id: "Human Resources",
    label: "Human Resources",
    items: [
      { id: "human_resources", label: "Human Resources" },
      { id: "compensation_benefits", label: "Compensation & Benefits" },
      { id: "culture_diversity_inclusion", label: "Culture, Diversity & Inclusion" },
      { id: "employee_labor_relations", label: "Employee & Labor Relations" },
      { id: "health_safety", label: "Health & Safety" },
      { id: "human_resource_information_system", label: "HR Information System" },
      { id: "hr_business_partner", label: "HR Business Partner" },
      { id: "learning_development", label: "Learning & Development" },
      { id: "organizational_development", label: "Organizational Development" },
      { id: "recruiting_talent_acquisition", label: "Recruiting & Talent Acquisition" },
      { id: "talent_management", label: "Talent Management" },
      { id: "workforce_mangement", label: "Workforce Management" }
    ]
  },
  {
    id: "IT",
    label: "IT",
    items: [
      { id: "information_technology", label: "Information Technology" },
      { id: "application_development", label: "Application Development" },
      { id: "business_service_management_itsm", label: "Business Service Management (ITSM)" },
      { id: "collaboration_web_app", label: "Collaboration & Web App" },
      { id: "data_center", label: "Data Center" },
      { id: "data_warehouse", label: "Data Warehouse" },
      { id: "database_administration", label: "Database Administration" },
      { id: "ecommerce_development", label: "E-Commerce Development" },
      { id: "enterprise_architecture", label: "Enterprise Architecture" },
      { id: "help_desk_desktop_services", label: "Help Desk & Desktop Services" },
      { id: "hr_financial_erp_systems", label: "HR & Financial ERP Systems" },
      { id: "information_security", label: "Information Security" },
      { id: "infrastructure", label: "Infrastructure" },
      { id: "it_asset_management", label: "IT Asset Management" },
      { id: "it_audit_it_compliance", label: "IT Audit & Compliance" },
      { id: "it_operations", label: "IT Operations" },
      { id: "it_procurement", label: "IT Procurement" },
      { id: "it_strategy", label: "IT Strategy" },
      { id: "networking", label: "Networking" },
      { id: "project_program_management", label: "Project & Program Management" },
      { id: "quality_assurance", label: "Quality Assurance" },
      { id: "retail_store_systems", label: "Retail Store Systems" },
      { id: "servers", label: "Servers" },
      { id: "storage_disaster_recovery", label: "Storage & Disaster Recovery" },
      { id: "telecommunications", label: "Telecommunications" },
      { id: "virtualization", label: "Virtualization" }
    ]
  },
  {
    id: "Legal",
    label: "Legal",
    items: [
      { id: "legal", label: "Legal" },
      { id: "compliance", label: "Compliance" },
      { id: "contracts", label: "Contracts" },
      { id: "ediscovery", label: "eDiscovery" },
      { id: "governmental_affairs_regulatory_law", label: "Governmental Affairs & Regulatory Law" },
      { id: "intellectual_property_patent", label: "Intellectual Property & Patent" },
      { id: "labor_employment", label: "Labor & Employment" },
      { id: "lawyer_attorney", label: "Lawyer / Attorney" },
      { id: "legal_counsel", label: "Legal Counsel" },
      { id: "legal_operations", label: "Legal Operations" },
      { id: "litigation", label: "Litigation" },
      { id: "privacy", label: "Privacy" }
    ]
  },
  {
    id: "Marketing",
    label: "Marketing",
    items: [
      { id: "marketing", label: "Marketing" },
      { id: "digital_marketing", label: "Digital Marketing" },
      { id: "advertising", label: "Advertising" },
      { id: "brand_management", label: "Brand Management" },
      { id: "content_marketing", label: "Content Marketing" },
      { id: "customer_experience", label: "Customer Experience" },
      { id: "customer_marketing", label: "Customer Marketing" },
      { id: "demand_generation", label: "Demand Generation" },
      { id: "ecommerce_marketing", label: "E-Commerce Marketing" },
      { id: "event_marketing", label: "Event Marketing" },
      { id: "field_marketing", label: "Field Marketing" },
      { id: "lead_generation", label: "Lead Generation" },
      { id: "marketing_analytics_insights", label: "Marketing Analytics & Insights" },
      { id: "marketing_communications", label: "Marketing Communications" },
      { id: "product_marketing", label: "Product Marketing" },
      { id: "public_relations", label: "Public Relations" },
      { id: "search_engine_optimization_pay_per_click", label: "SEO / Pay-Per-Click" },
      { id: "social_media_marketing", label: "Social Media Marketing" },
      { id: "strategic_communications", label: "Strategic Communications" },
      { id: "technical_marketing", label: "Technical Marketing" }
    ]
  },
  {
    id: "Medical",
    label: "Medical",
    items: [
      { id: "medical_health", label: "Medical & Health" },
      { id: "chiropractics", label: "Chiropractics" },
      { id: "dentistry", label: "Dentistry" },
      { id: "doctors_physicians", label: "Doctors & Physicians" },
      { id: "first_responder", label: "First Responder" },
      { id: "infectious_disease", label: "Infectious Disease" },
      { id: "medical_administration", label: "Medical Administration" },
      { id: "medical_education_training", label: "Medical Education & Training" },
      { id: "medicine", label: "Medicine" },
      { id: "neurology", label: "Neurology" },
      { id: "nursing", label: "Nursing" },
      { id: "nutrition_dietetics", label: "Nutrition & Dietetics" },
      { id: "oncology", label: "Oncology" },
      { id: "pathology", label: "Pathology" },
      { id: "pharmacy", label: "Pharmacy" },
      { id: "physical_therapy", label: "Physical Therapy" },
      { id: "psychology", label: "Psychology" },
      { id: "public_health", label: "Public Health" },
      { id: "radiology", label: "Radiology" },
      { id: "social_work", label: "Social Work" }
    ]
  },
  {
    id: "Operations",
    label: "Operations",
    items: [
      { id: "operations", label: "Operations" },
      { id: "c_suite", label: "C-Suite" },
      { id: "executive", label: "Executive" },
      { id: "founder", label: "Founder" },
      { id: "project_management", label: "Project Management" },
      { id: "call_center", label: "Call Center" },
      { id: "construction", label: "Construction" },
      { id: "corporate_strategy", label: "Corporate Strategy" },
      { id: "customer_service_support", label: "Customer Service & Support" },
      { id: "enterprise_resource_planning", label: "Enterprise Resource Planning" },
      { id: "facilities_management", label: "Facilities Management" },
      { id: "leasing", label: "Leasing" },
      { id: "logistics", label: "Logistics" },
      { id: "office_operations", label: "Office Operations" },
      { id: "physical_security", label: "Physical Security" },
      { id: "project_development", label: "Project Development" },
      { id: "quality_management", label: "Quality Management" },
      { id: "real_estate", label: "Real Estate" },
      { id: "store_operations", label: "Store Operations" },
      { id: "supply_chain", label: "Supply Chain" }
    ]
  },
  {
    id: "Sales",
    label: "Sales",
    items: [
      { id: "sales", label: "Sales" },
      { id: "field_outside_sales", label: "Field / Outside Sales" },
      { id: "customer_success", label: "Customer Success" },
      { id: "account_management", label: "Account Management" },
      { id: "business_development", label: "Business Development" },
      { id: "channel_sales", label: "Channel Sales" },
      { id: "customer_retention_development", label: "Customer Retention & Development" },
      { id: "inside_sales", label: "Inside Sales" },
      { id: "partnerships", label: "Partnerships" },
      { id: "sales_enablement", label: "Sales Enablement" },
      { id: "sales_engineering", label: "Sales Engineering" },
      { id: "sales_operations", label: "Sales Operations" },
      { id: "sales_training", label: "Sales Training" }
    ]
  },
  {
    id: "Consulting",
    label: "Consulting",
    items: [
      { id: "consulting", label: "Consulting" },
      { id: "consultant", label: "Consultant" }
    ]
  },
  {
    id: "Education",
    label: "Education",
    items: [
      { id: "education", label: "Education" },
      { id: "teacher", label: "Teacher" },
      { id: "principal", label: "Principal" },
      { id: "superintendent", label: "Superintendent" },
      { id: "professor", label: "Professor" }
    ]
  }
];

/**
 * Build options for CustomMultiSelect: top-level categories with submenu of items.
 * Each option: { id, value, show, showSubmenu, submenu: [ { id: apiValue, name: label, value: label, show } ] }
 */
export function buildJobFunctionOptions() {
  return JOB_FUNCTION_CATEGORIES.map(cat => ({
    id: cat.id,
    value: cat.label,
    show: true,
    showSubmenu: true,
    submenu: (cat.items || []).map(item => ({
      id: item.id,
      name: item.label,
      value: item.label,
      show: true
    }))
  }));
}
